export function sortBySequence(rows) {
  return [...rows].sort((a, b) => {
    const sa = Number(a.sequence ?? a.Sequence ?? 0);
    const sb = Number(b.sequence ?? b.Sequence ?? 0);
    return sa - sb;
  });
}